import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import PublishedNote from './components/PublishedNote';
import { restoreQueryCache, startQueryCachePersistence } from './queryCachePersistence';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Check if this is a published note URL
const publishedMatch = window.location.pathname.match(/^\/p\/([^/]+)$/);

const root = ReactDOM.createRoot(document.getElementById('root'));

restoreQueryCache(queryClient).finally(() => {
  startQueryCachePersistence(queryClient);

  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        {publishedMatch ? <PublishedNote slug={publishedMatch[1]} /> : <App />}
      </QueryClientProvider>
    </React.StrictMode>
  );
});
